import {
  createStore as createReduxStore,
  applyMiddleware,
  compose,
} from 'redux';
import thunkMiddleware from 'redux-thunk';
import { persistStore } from 'redux-persist';
import monitorReducerEnhancer from '@/store/enhancers/monitorReducer';
import loggerMiddleware from '@/store/logger.middleware';
import rootReducer from '@/store/reducers';
import ResetMiddleware from './ResetMiddleware';

declare global {
  interface Window {
    __REDUX_DEVTOOLS_EXTENSION_COMPOSE__?: (...args: any[]) => any;
  }
}

const createStoreFactory = (initialState = {}) => {
  /**
  |--------------------------------------------------
  | Middleware Configuration
  |--------------------------------------------------
  */
  const middleware: any[] = [thunkMiddleware];

  // Only enable logger if explicitly enabled via environment variable
  if (process.env.ENABLE_REDUX_LOGGER === 'true') {
    middleware.push(loggerMiddleware);
  }

  /**
  |--------------------------------------------------
  | Store Enhancers
  |--------------------------------------------------
  */
  const enhancers: any[] = [monitorReducerEnhancer, ResetMiddleware];
  let composeEnhancers: any = compose;

  if (process.env.NODE_ENV === 'development') {
    if (typeof window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ === 'function') {
      composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__;
    }
  }

  /**
  |--------------------------------------------------
  | Store Instantiation and HMR Setup
  |--------------------------------------------------
  */
  const store: any = createReduxStore(
    rootReducer,
    initialState,
    composeEnhancers(applyMiddleware(...middleware), ...enhancers),
  );
  store.asyncReducers = {};
  return store;
};

export const createStore = createStoreFactory;
export const store = createStoreFactory();
export const persistor = persistStore(store);
